import {
  commonValidationSchemas,
  createValidationSchema,
} from 'infrastructure/functions';

export const createCampaignSchema = () =>
  createValidationSchema({
    name: commonValidationSchemas.string({
      required: true,
    }),
    questionKey: commonValidationSchemas.string({ required: true }),
  });

export const updateCampaignSchema = () =>
  createValidationSchema({
    name: commonValidationSchemas.string({
      required: true,
    }),
  });
